<template>
    <div class="auth-wrapper auth-v2">
        
        <b-row class="auth-inner m-0">
            
            <b-col lg="4" class="d-flex  auth-bg px-0 p-lg-0">
                
                <div class="w-100 d-flex flex-column justify-content-between">
                    <HeaderBar/>
                    <!-- form -->
                    <validation-observer ref="loginForm" #default="{ invalid }">
                        <div class="px-2">
                            <div class="d-flex justify-content-center align-items-center mt-4 pt-4">
                                <img src="@/assets/images/logo/logoNew.png" />
                            </div>
                            <h2 class="brand-text  mt-3 d-flex justify-content-center align-items-center">
                                Bienvenido a GANAPP
                            </h2>
                            <b-form class="auth-login-form mx-5">
                                <!-- buttons -->
                                <!-- <b-button class="bg-primary mt-2 buttonPro" block>
                                <b-link :to="{name:'basic-home'}" style="color:white"> Módulo Básico</b-link>
                                </b-button> -->
                                <b-button class="bg-primary mt-1 buttonPro" block>
                                  <b-link :to="{name:'advance-home'}" style="color:white">  Explorar Herramientas</b-link> 
                                </b-button>
    
                            </b-form>
                            <div class="d-flex flex-column justify-content-center align-items-center mb-2 mt-2 px-2" style="font-size: 15px; font-weight: 500;">
                                <div>Podrá llevar las estadísticas de su</div>
                                <div>finca, recibir recomendaciones y</div>
                                <div>asesoría de forma gratuita</div>
                            </div>
                            <div class="d-flex align-items-start flex-wrap justify-content-around pb-2">
                                <img src="@/assets/images/ganImage/1.png" width="120" />
                            </div>
                            <!-- <div class="d-flex align-items-center text-center flex-wrap  ">
                                <div class="row">
                                    <div class="col-md-3 col-lg-6 col-6 mb-2">
                                        <img src="@/assets/images/ganImage/2.png" width="80" />
                                    </div>
                                    <div class="col-md-3 col-lg-6 col-6  mb-2">
                                        <img src="@/assets/images/ganImage/3.png" width="80" />
                                    </div>
                                    <div class="col-md-3 col-lg-6 col-6">
                                        <img src="@/assets/images/ganImage/4.png" width="80"/>
                                    </div>
                                    <div class="col-md-3 col-lg-6 col-6">
                                        <img src="@/assets/images/ganImage/5.png" width="80"/>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </validation-observer>
                    <ControlMenu />
                </div>
            </b-col>
        </b-row>

    </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import {
    BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import ControlMenu from './ControlMenu.vue'
import HeaderBar from './HeaderBar.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    directives: {
        'b-tooltip': VBTooltip,
    },
    components: {
        BRow,
        BCol,
        BLink,
        BFormGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroup,
        BFormCheckbox,
        BCardText,
        BCardTitle,
        BImg,
        BForm,
        BButton,
        BAlert,
        ValidationProvider,
        ValidationObserver,
        ControlMenu,
        HeaderBar,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            status: '',
            password: 'admin',
            userEmail: 'admin@demo.com',


            // validation rules
            required,
            email,
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
        imgUrl() {
            if (store.state.appConfig.layout.skin === 'dark') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
                return this.sideImg
            }
            return this.sideImg
        },
    },
    methods: {

        defaultFarm(config){
            if(localStorage.getItem('currentFarm')==null){
                fetch(this.$apiUrl+"list/FarmsViews", config)
                .then(response => response.json())
                .then(result => {
                    console.log(result.FarmsViews);
                    localStorage.setItem('currentFarm', result.FarmsViews[0].id) ;
                    localStorage.setItem('currentFarmName',result.FarmsViews[0].cvo+' '+result.FarmsViews[0].name);
                    
                })
            }
        },
        createFirstAlert(){
            if(localStorage.getItem('desteteShowed')===null ||localStorage.getItem('desteteShowed') === 'false'){
                this.$swal({
                    title: '🎉 ¡Nueva función! Configure los meses de destete en su finca 🎉',
                    text: 'Estimado usuario, le informamos que hemos incorporado una nueva funcionalidad a la aplicación para optimizar la gestión de su finca. Ahora, le solicitamos amablemente configurar los meses de destete de sus animales. Esta información es valiosa para poder ofrecerle recomendaciones más precisas y mejorar su experiencia con nuestra plataforma.',
                    type: 'info',
                    icon:'success',
                    showCancelButton: false,
                    confirmButtonColor:'#5E8F23',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(() => {
                    // Set desteteShowed to true in localStorage after the alert is confirmed
                    localStorage.setItem('desteteShowed', 'true');
                });
            }
        }
    },
    created(){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.defaultFarm(config);
        this.createFirstAlert();
    }
}
</script>

<style lang="scss">
.buttonPro {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.4px;
}

@import '@core/scss/vue/pages/page-auth.scss';
</style>
